<template>
  <div class="capacity-settle-page">
    <ContentWrap>
      <el-alert
        class="mb-12px"
        type="info"
        :closable="false"
        title="运营端 · 分润打款：机构已确认的账单可标记已打款。机构确认/异议在「紫金山骑手机构端 → 分润对账」。"
      />
      <el-button class="mb-12px" type="primary" @click="loadAll">刷新</el-button>
      <el-table
        :data="allBills"
        v-loading="loading"
        size="small"
        border
        class="w-full"
        style="width: 100%"
        empty-text="暂无待打款账单"
      >
        <el-table-column prop="orgId" label="机构" min-width="140" />
        <el-table-column prop="period" label="周期" min-width="120" />
        <el-table-column label="分润" min-width="120">
          <template #default="{ row }">¥{{ formatAmount(row.amount) }}</template>
        </el-table-column>
        <el-table-column label="状态" min-width="120">
          <template #default="{ row }">
            <el-tag :type="statusTagType(row.status)" size="small">{{ statusLabel(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template #default="{ row }">
            <el-button
              v-if="row.status === 'confirmed'"
              link
              type="primary"
              @click="onPaid(row.billId)"
            >
              标记打款
            </el-button>
            <span v-else class="text-13px text-[var(--el-text-color-secondary)]">—</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :total="total"
        v-model:page="pageNo"
        v-model:limit="pageSize"
        @pagination="loadAll"
      />
    </ContentWrap>
  </div>
</template>

<script lang="ts" setup>
import * as WalletApi from '@/api/capacity/wallet'
import { ContentWrap } from '@/components/ContentWrap'
import { ElMessage } from 'element-plus'

defineOptions({ name: 'CapacitySettlePlatform' })

const STATUS_LABEL: Record<string, string> = {
  draft: '草稿',
  pending: '待确认',
  confirmed: '已确认',
  disputed: '有异议',
  paid: '已打款'
}

const allBills = ref<WalletApi.OrgBill[]>([])
const pageNo = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loading = ref(false)

const formatAmount = (v?: number | string) =>
  Number(v ?? 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const statusLabel = (s?: string) => STATUS_LABEL[s || ''] || s || '—'

const statusTagType = (s?: string) => {
  if (s === 'paid') return 'success'
  if (s === 'confirmed') return 'warning'
  if (s === 'disputed') return 'danger'
  if (s === 'pending') return 'info'
  return 'info'
}

const loadAll = async () => {
  loading.value = true
  try {
    const r = await WalletApi.listAllBills({
      pageNo: pageNo.value,
      pageSize: pageSize.value,
    })
    allBills.value = r?.list || []
    total.value = r?.total || 0
  } finally {
    loading.value = false
  }
}

const onPaid = async (billId: string) => {
  const r = await WalletApi.markPaid(billId)
  if (!r.success) return ElMessage.error(r.message || '打款标记失败')
  ElMessage.success('已标记打款')
  await loadAll()
}

onMounted(loadAll)
</script>

<style scoped>
.capacity-settle-page {
  width: 100%;
  box-sizing: border-box;
}
.capacity-settle-page :deep(.el-card) {
  width: 100%;
}
</style>
